<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.push('/empresas')">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>

      <b-card-header class="border-0">
        <h3 class="mb-0">{{ $t('empresa') }} : {{ empresa.nombre }}</h3>

        <b-form @submit.prevent="submitForm">
          <div class="d-flex justify-content-end">
            <b-button @click="isEditMode = !isEditMode" :variant="!isEditMode ? 'info' : 'danger'">
              {{ !isEditMode ? $t('editar') : $t('cancelar') }}
            </b-button>

            <b-button v-if="isEditMode" :disabled="!isEditMode" type="submit" variant="primary" class="ml-2">
              {{ $t('actualizar') }}
            </b-button>
          </div>

          <b-row>
            <b-col md="3">
              <b-form-group label-for="Nombre">
                <template v-slot:label>
                  {{ $t('nombre') }} <span v-if="isEditMode" class="text-danger">*</span>
                </template>
                <b-form-input id="nombre" :disabled="!isEditMode" v-model="empresa.nombre" required
                  placeholder="Ingrese nombre"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="rut" label-for="rut">
                <template v-slot:label>
                  {{ $t('rut') }} <span v-if="isEditMode" class="text-danger">*</span>
                </template>
                <b-form-input id="rut" :disabled="!isEditMode" v-model="empresa.rut" required></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Pais" label-for="paisID">
                <template v-slot:label>
                  {{ $t('pais') }} <span v-if="isEditMode" class="text-danger">*</span>
                </template>
                <b-form-select id="paisID" :disabled="!isEditMode" v-model="empresa.paisID" required
                  @change="onChangePais">
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                  <option v-for="option in paisOptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="industriaID" label-for="industriaID">
                <template v-slot:label>
                  {{ $t('industria') }}
                </template>
                <b-form-select id="industriaID" :disabled="!isEditMode" v-model="empresa.industriaID">
                  <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                  <option v-for="option in industriasOptions" :key="option.value" :value="option.value">
                    {{ option.text }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="2">
              <b-form-group label-for="regionID">
                <template v-slot:label>
                  {{ $t('region') }} <span v-if="isEditMode" class="text-danger">*</span>
                </template>
                <el-select class="custom-input" :disabled="!isEditMode || !(this.empresa.paisID > 0)"
                  v-model="empresa.regionID" filterable @change="onChangeRegion" :placeholder="$t('seleccione_opcion')"
                  style="width: 100%;">
                  <el-option :value="null" :label="$t('seleccione_opcion')" />
                  <el-option v-for="item in regionOptions" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label-for="comunaID">
                <template v-slot:label>
                  {{ $t('comuna') }} <span v-if="isEditMode" class="text-danger">*</span>
                </template>

                <el-select class="custom-input" :disabled="!isEditMode || !(this.empresa.regionID > 0)"
                  v-model="empresa.comunaID" filterable :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                  <el-option :value="null" :label="$t('seleccione_opcion')" />
                  <el-option v-for="item in comunasOptions" :key="item.value" :label="item.text" :value="item.value" />
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="direccion">
                <template v-slot:label>
                  {{ $t('calle') }} <span v-if="isEditMode" class="text-danger">*</span>
                </template>
                <b-form-input id="direccion" :disabled="!isEditMode" v-model="empresa.direccion" required
                  placeholder="Ingrese direccion"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label-for="numero">
                <template v-slot:label>
                  {{ $t('Numero') }}
                </template>
                <b-form-input type="number" id="numeroDireccion" :disabled="!isEditMode"
                  v-model="empresa.numeroDireccion" placeholder="Ingrese #"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label-for="parcela">
                <template v-slot:label>
                  {{ $t('dir_lugar_tipo') }}
                </template>
                <b-form-input id="parcela" :disabled="!isEditMode" v-model="empresa.parcela"
                  :placeholder="'Ingrese ' + $t('dir_lugar_tipo')"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
          <b-col md="2">
              <b-form-group label-for="swFolioPropio">
                <b-form-checkbox id="swFolioPropio" :disabled="!isEditMode" v-model="empresa.swFolioPropio">
                  {{ $t('folio_propio') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
            
        </b-form>
      </b-card-header>
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <UserTable />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import empresaService from '@/api/empresaService';
import UserTable from '@/views/Usuario/UsersTable.vue';
import MaterialTable from "@/views/Material/MaterialTable.vue";
import miscService from '@/api/miscService';
import { Select, Option } from 'element-ui'
export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    UserTable,
    MaterialTable
  },
  data() {
    return {
      isEditMode: false,
      empresa: {},
      paisOptions: [],
      regionOptions: [],
      comunasOptions: [],
      industriasOptions: [],
      sectoresOptions: []
    };
  },
  async beforeMount() {
    const id = this.$route.params.id;
    this.paisOptions = await miscService.getPaisesOptions();
    this.industriasOptions = await miscService.getIndustriaOptions();
    this.sectoresOptions = await miscService.getSectorOptions();
    this.empresa = await empresaService.get(id);
    if (this.empresa.paisID > 0)
      this.regionOptions = await miscService.getRegionesOptions(this.empresa.paisID);
    if (this.empresa.regionID > 0)
      this.comunasOptions = await miscService.getComunasOptions(this.empresa.regionID);
  },
  methods: {
    async onChangePais() {
      this.empresa.regionID = null;
      this.empresa.comunaID = null;
      if (this.empresa.paisID > 0)
        this.regionOptions = await miscService.getRegionesOptions(this.empresa.paisID);

    },
    async onChangeRegion() {
      this.empresa.comunaID = null;
      if (this.empresa.regionID > 0)
        this.comunasOptions = await miscService.getComunasOptions(this.empresa.regionID);
    },
    async submitForm() {
      Swal.fire({
        title: this.$t('estas_seguro'),
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });

            const response = await empresaService.update(this.empresa, this.empresa.id);
            if (!response) throw new Error(this.$t('error_guardar'));
            this.empresa = await empresaService.get(this.empresa.id);
            this.isEditMode = false;
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$t('error_2'),
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    }
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
